import { fmtDateTime, fmtNumber, fullName } from './adminFormat';

// Column definitions for the Events tab (PaginatedTable headCells). The rows come
// from BigQuery via /admin/events/*; for the top-events table `id` doubles as the
// sortField the server accepts (count | visitors | users | category).

const textCell = (val) => val || '—';
const numberCell = (val) => fmtNumber(val);

export const topEventColumns = [
    { id: 'category', label: 'Category', sortable: false, render: textCell },
    { id: 'action', label: 'Action', sortable: false, render: textCell },
    { id: 'label', label: 'Label', sortable: false, render: textCell },
    { id: 'count', label: 'Count', numeric: true, render: numberCell },
    { id: 'visitors', label: 'Visitors', numeric: true, render: numberCell },
    { id: 'users', label: 'Signed-in users', numeric: true, render: numberCell },
];

export const pageColumns = [
    { id: 'page', label: 'Page', sortable: false, render: textCell },
    { id: 'views', label: 'Views', numeric: true, sortable: false, render: numberCell },
    { id: 'visitors', label: 'Visitors', numeric: true, sortable: false, render: numberCell },
    { id: 'sessions', label: 'Sessions', numeric: true, sortable: false, render: numberCell },
];

// Signed-in users ranked by activity. Lesson columns come from Postgres and are
// not server-sortable; the others are BigQuery aggregates (ids = sortField).
export const userColumns = [
    {
        id: 'email',
        label: 'User',
        sortable: false,
        render: (val, row) => {
            const name = fullName(row);
            return name ? `${name} (${val || row.userId})` : val || row.userId;
        },
    },
    { id: 'lessonsStarted', label: 'Lessons started', numeric: true, sortable: false, render: numberCell },
    { id: 'lessonsJoined', label: 'Lessons joined', numeric: true, sortable: false, render: numberCell },
    { id: 'lessonMinutes', label: 'Lesson minutes', numeric: true, sortable: false, render: numberCell },
    { id: 'tools', label: 'Tool uses', numeric: true, render: numberCell },
    { id: 'ai', label: 'AI calls', numeric: true, render: numberCell },
    { id: 'events', label: 'Events', numeric: true, render: numberCell },
    { id: 'activeDays', label: 'Active days', numeric: true, render: numberCell },
    { id: 'lastActive', label: 'Last active', render: (val) => fmtDateTime(val) },
];

export const breakdownColumns = [
    { id: 'value', label: 'Value', sortable: false, render: textCell },
    { id: 'visitors', label: 'Visitors', numeric: true, sortable: false, render: numberCell },
    { id: 'events', label: 'Events', numeric: true, sortable: false, render: numberCell },
];
